<style>
  .alarm{
    background-color:#ff9595 !important;
  }



</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Verify Behfa Equipment Check-in </h5>
     <br/>

     <br>
     <br>

     <div class="row">
      <div  class="form-group col-md-12" >
        <button  type="button" (click)="ReadData_DeviceBehfa()" class="btn btn-info" 
        style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        
        <button *ngIf="!Procssing" [disabled]="ids=='-1'" (click)="openModal(templateOperationList,1,0)" type="button" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa fa-plus-circle"></i> Approve </button>
        
        <button *ngIf="!Procssing" [disabled]="ids=='-1'" (click)="openModal(templateOperationList,2,0)" type="button" class="btn btn-warning"
        style="margin-right: 5px;"><i class="fa fa-wrench"></i> Service and Repair Required  </button>
        
        <button *ngIf="!Procssing" [disabled]="ids=='-1'" (click)="openModal(templateOperationList,3,0)" type="button" class="btn btn-danger"
        style="margin-right: 5px;"><i class="fa fa-warning"></i> Not Available in the Laboratory  </button>
        
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>

     </div>

     <br>
     <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>
                <input type="checkbox" [checked]="Check_All" (click)="onChange_CheckAll()" />
              </th>
              <th>#</th>
              <th>Description</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Name User</th>
              <th>Reception Date</th>
              <th>Exit Reason</th>
              <th>Delivery Date</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfa).length
                      }
            " [ngClass]="{'alarm': item.alarm===1}" >
            <td>
              <input type="checkbox" *ngIf="item.status==1 || item.status==2" [checked]="item.selected"
                (click)="onChange_CheckItem(item)" />
            </td>
            <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
            <td class="EnglishClm">{{item.description}}</td>
            <td class="EnglishClm">{{item.model}}</td>
            <td class="EnglishClm">{{item.codeBEHFA}}</td>
            <td>{{item.username}}</td>
            <td>{{item.downloadDate}}</td>
            <td>{{item.downloadType}}</td>
            <td>{{item.uploadDate}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div  class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(templateOperation,1,item.id)"><i class="fa fa-plus-circle"></i> Approve </a>
                      <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(templateOperation,2,item.id)"><i class="fa  fa-wrench"></i>	Service and Repair Required </a>
                      <a *ngIf="item.alarm==0" style="cursor: pointer;" class="dropdown-item" (click)="openModal(templateOperation,3,item.id)"><i class="fa  fa-warning"></i>	Not Available in the Laboratory </a>
                  </div>
              </div>
            </div>
            </td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_DeviceBehfaTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>


<ng-template #templateOperation>
  <div class="modal-header">
     <h4 *ngIf="Operation==1" class="modal-title pull-left"> Approve </h4>
     <h4 *ngIf="Operation==2" class="modal-title pull-left"> Service and Repair Required  </h4>
     <h4 *ngIf="Operation==3" class="modal-title pull-left"> Not Available in the Laboratory </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_operation.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Description </label>
          <input [(ngModel)]="OperationDsc"  name="OperationDsc"  type="text"  class="form-control "   placeholder="Type here...">
      </div>

    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing && Operation==1" (click)="Confirm()" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Approve </button>
    <button *ngIf="!InProccessing && Operation==2" (click)="Confirm()" type="button" [disabled]="!OperationDsc" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-wrench"></i>	Service and Repair Required </button>
    <button *ngIf="!InProccessing && Operation==3" (click)="Confirm()" type="button" [disabled]="!OperationDsc" class="btn btn-warning" style="margin-right: 5px;"><i class="fa  fa-warning"></i>	Not Available in the Laboratory </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_operation.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateOperationList>
  <div class="modal-header">
     <h4 *ngIf="Operation==1" class="modal-title pull-left"> Approve </h4>
     <h4 *ngIf="Operation==2" class="modal-title pull-left"> Service and Repair Required  </h4>
     <h4 *ngIf="Operation==3" class="modal-title pull-left"> Not Available in the Laboratory </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_operation.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Description </label>
          <input [(ngModel)]="OperationDsc"  name="OperationDsc"  type="text"  class="form-control "   placeholder="Type here...">
      </div>

    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing && Operation==1" (click)="ConfirmList()" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Approve </button>
    <button *ngIf="!InProccessing && Operation==2" (click)="ConfirmList()" type="button" [disabled]="!OperationDsc" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-wrench"></i>	Service and Repair Required </button>
    <button *ngIf="!InProccessing && Operation==3" (click)="ConfirmList()" type="button" [disabled]="!OperationDsc" class="btn btn-warning" style="margin-right: 5px;"><i class="fa  fa-warning"></i>	Not Available in the Laboratory </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_operation.hide()">Close</button>
  </div>
</ng-template>
